// Package imports
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { makeStyles } from "@material-ui/core/styles";
import { List, Typography, IconButton } from "@mui/material";
import { Box } from "@mui/system";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import TextField from "@mui/material/TextField";
import { unicodeToString } from "../../../../Js/Common";
import { currentAssetSliceActions } from "../../../../Store/Slices/CurrentAssetSlice";
import OptionMedia from "../../../../Components/Card/AssetUI/OptionMedia";
import StatusIndicator from "../../../../Components/Card/AssetUI/StatusIndicator";

// Global variables
var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};

const refData = [];

// Component
function FIBTYPO(props) {
  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();

  // State
  let [userAnswer, setUserAnswer] = useState([]);
  let [logObj, setLogObj] = useState(initLogObj);
  let [fibContent, setFibContent] = useState([]);
  let [currentIndexPlay, setCurrentIndexPlay] = useState([]);

  // Redux state
  const { showAnswer, assetLogObj, attempted, currentAttempt, optionWiseAns } =
    useSelector((state) => state.currentAsset);

  useEffect(() => {
    if (props.content) {
      let actualAnswers = [];
      let userAnswers = [];
      let innerAnsArr, userAnsArray, innerAnsArr1, userAnsArray1;
      let content = props.content.epage.options.content.map((val, index) => {
        let obj = { ...val };
        let tempstr = obj.text;
        let str;

        if (obj.answer.length === 0) {
          tempstr = unicodeToString(tempstr);
          console.log("IAMHEREEEEEEEEE");
          innerAnsArr = [[]];
        } else {
          innerAnsArr = [];
          obj.answer.forEach((ans, index1) => {
            innerAnsArr1 = [];
            userAnsArray = [];
            if (ans.length > 0) {
              ans.forEach((innerAns, index2) => {
                innerAnsArr1.push(unicodeToString(innerAns.value));
                console.log("index", index);
                console.log("index1", index1);
                console.log("index2", index2);
                if (innerAns.status == true) {
                  let replace_str =
                    '<span class="btn btn--small blue" id="btn_' +
                    index +
                    "_" +
                    index1 +
                    '" contenteditable="false">' +
                    unicodeToString(unicodeToString(innerAns.value)) +
                    "</span>";
                  if (!str) {
                  }
                  str = unicodeToString(tempstr);
                  if (str) {
                    str = str.replace(/^<div[^>]*>|<\/div>$/g, "");
                    str = str.replace(/&nbsp;/g, " ");
                    str = str.replace(
                      replace_str,
                      "***|_btn_" + index + "_" + index1 + " "
                    );
                    str = str.replace("<br>", "");
                    str = str.replace(/\n/g, " ");
                    tempstr = str;
                  }
                }
              });
              innerAnsArr.push(innerAnsArr1);
            }
          });
        }
        console.log("!!!!tempstr", tempstr);
        actualAnswers.push(innerAnsArr);
        userAnswers.push(new Array(obj.answer.length).fill(""));
        return tempstr;
      });
      //console.log("ans",ans);
      setFibContent(content);
      setUserAnswer(userAnswers);
      setCurrentIndexPlay(
        new Array(props.content.epage.options.content.length).fill(false)
      );
      dispatch(currentAssetSliceActions.setCurrentAttemptData(userAnswers));
      console.log("userAnsArray", userAnswers);
      let obj = {
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
        actualAnswer: actualAnswers,
      };

      setLogObj(obj);
    }
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
    dispatch(currentAssetSliceActions.setShowAnswer(false));
  }, [logObj]);

  useEffect(() => {
    if (
      (props.content.epage.options.autoMode &&
        props.content.epage.options.autoMode.toString() == "true") ||
      props.content.epage.options.autoMode == undefined
    ) {
      dispatch(currentAssetSliceActions.setShowAnswer(false));
      let userAns = props.content.epage.options.content.map((val) => {
        return new Array(val.answer.length).fill("");
      });
      setUserAnswer(userAns);
      dispatch(currentAssetSliceActions.setCurrentAttemptData(userAns));
    } else {
      console.log("elseeeeee");
    }
  }, [currentAttempt]);

  useEffect(() => {
    if (showAnswer && assetLogObj && assetLogObj.actualAnswer) {
      let showAllAnswer = assetLogObj.actualAnswer.map((val) => {
        console.log("valvalvalval", val);
        return val.map((val1) => {
          return val1.join(" | ");
        });
      });
      setUserAnswer(showAllAnswer);
    }
  }, [showAnswer, assetLogObj]);

  useEffect(() => {
    return () => {
      setUserAnswer([]);
    };
  }, []);

  const updateUserAnswer = (index, valIndex, text) => {
    if (!showAnswer && !attempted) {
      let newArray = [...userAnswer];
      let innerArray = newArray[index].map((item, i) => {
        if (valIndex === i) {
          return text;
        } else {
          return item;
        }
      });
      newArray[index] = [...innerArray];
      setUserAnswer(newArray);
      dispatch(currentAssetSliceActions.setCurrentAttemptData([...newArray]));
    }
  };

  const updateUserAnswerTrim = (index, valIndex) => {
    if (!showAnswer && !attempted) {
      let newArray = [...userAnswer];
      let innerArray = newArray[index].map((item, i) => {
        return item.trim();
      });
      newArray[index] = [...innerArray];
      setUserAnswer(newArray);
      dispatch(currentAssetSliceActions.setCurrentAttemptData([...newArray]));
    }
  };

  const getBlankIndex = (que) => {
    let count = 0;
    que = que.replace(/<[^>]*>?/gm, "");
    return que.split(" ").map((val) => {
      if (val.includes("*")) {
        return {
          word: val,
          ind: count++,
          lengthinput: 10,
          buttonid: val.split("|_")[1],
        };
      } else {
        return {
          word: val,
          lengthinput: 10,
        };
      }
    });
  };

  const setPlayMode = (status, index, end) => {
    if (status == true && !end && !currentIndexPlay[index]) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      arr[index] = status;
      setCurrentIndexPlay(arr);
    }
    if (currentIndexPlay[index] || end) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      setCurrentIndexPlay(arr);
    }
  };

  // JSX template

  return (
    <div  >
      {props.content &&
        props.content.epage.options.content.map((opt, index) => {
          return (
            <Box sx={{ mt: 4 }} key={`${index}_options`}>
              <List
                dense
                sx={{
                  borderBottom: 2,
                  borderBottomColor: "#EFEFEF",
                  padding: 0,
                  paddingBottom: 1,
                  my: 2,
                }}
              >
                <ListItem
                  sx={{
                    pa: 0,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    paddingLeft: "2px",
                    paddingRight: "2px",
                  }}
                >
                  {opt && opt.media && (
                    <OptionMedia
                      media={opt.media}
                      isPlaying={currentIndexPlay[index]}
                      setPlayMode={(status, end) => {
                        setPlayMode(status, index, end);
                      }}
                    ></OptionMedia>
                  )}
                  <ListItemText
                    classes={{ primary: classes.ListItemText }}
                    sx={{ color: "primary.main", pl: 1 }}
                  >
                    {fibContent &&
                      fibContent.length > 0 &&
                      fibContent[index] &&
                      getBlankIndex(fibContent[index]).map((val, index1) => {
                        return (
                          <>
                            {!val.word.includes("*") && (
                              <Typography
                                color="primary.main"
                                sx={{
                                  lineHeight: 2.3,
                                  fontWeight: "500",
                                  fontSize: "0.9rem",
                                  display: "inline-block",
                                  mx: 0.5,
                                  "@media (min-width: 1636px)": {
                                    fontSize: "1.4rem",
                                  },
                                }}
                                key={`${index1}_text`}
                              >
                                {" "}
                                {val.word}
                              </Typography>
                            )}
                            {val.word.includes("*") && (
                              <TextField
                                size="small"
                                variant="standard"
                                inputProps={{
                                  sx: {
                                    fontSize: "0.9rem",
                                    color: "#DB8829",
                                    fontWeight: "500",
                                    minWidth: "8em",
                                    width: userAnswer[index][val.ind]
                                      ? window.innerWidth > 1580
                                        ? `${
                                            userAnswer[index][val.ind].length *
                                            0.85
                                          }rem`
                                        : `${
                                            userAnswer[index][val.ind].length *
                                            0.55
                                          }rem`
                                      : `8em`,
                                    "@media (min-width: 1636px)": {
                                      fontSize: "1.4rem",
                                    },
                                  },
                                }}
                                sx={{
                                  minWidth: "8em",
                                  width: userAnswer[index][val.ind]
                                    ? window.innerWidth > 1580
                                      ? `${
                                          userAnswer[index][val.ind].length *
                                          0.85
                                        }rem`
                                      : `${
                                          userAnswer[index][val.ind].length *
                                          0.55
                                        }rem`
                                    : `8em`,
                                  mx: 1,
                                  "@media (min-width: 1636px)": {
                                    mt: 1,
                                  },
                                }}
                                color="primary"
                                onInput={(event) => {
                                  updateUserAnswer(
                                    index,
                                    val.ind,
                                    event.target.value
                                  );
                                }}
                                onBlur={(event) => {
                                  updateUserAnswerTrim(index, val.ind);
                                }}
                                value={userAnswer[index][val.ind]}
                                key={`${index1}_input`}
                                disabled={showAnswer && attempted}
                                focused
                                InputProps={{
                                  startAdornment: (
                                    <>
                                      {optionWiseAns &&
                                        optionWiseAns.length > 0 &&
                                        optionWiseAns[index] != undefined &&
                                        optionWiseAns[index][val.ind] != undefined && (
                                          <StatusIndicator
                                            correct={
                                              optionWiseAns[index][val.ind]
                                            }
                                          ></StatusIndicator>
                                        )}
                                    </>
                                  ),
                                }}
                              />
                            )}
                          </>
                        );
                      })}
                  </ListItemText>
                </ListItem>
              </List>
            </Box>
          );
        })}
    </div>
  );
}

const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
    height: "62vh",
    overflow: "auto",
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default FIBTYPO;
